import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from './shared.module';
import { ContractPdfComponent } from '../features/customer/components/contract-pdf/contract-pdf.component';
import { CustomerDetailsFormComponent } from '../features/customer/components/customer-details-form/customer-details-form.component';
import { JobAddressFormComponent } from '../features/customer/components/job-address-form/job-address-form.component';
import { CustomerAttachmentsComponent } from '../features/customer/components/customer-attachments/customer-attachments.component';
import { DetailsComponent } from '../features/sales-visit/components/steps/details/details.component';
import { ProdInitialWalkthroughFormComponent } from '../features/prod-visit/components/steps/prod-initial-walkthrough/prod-initial-walkthrough-form/prod-initial-walkthrough-form.component';
import { ProdInitialWalkthroughComponent } from '../features/prod-visit/components/steps/prod-initial-walkthrough/prod-initial-walkthrough.component';
import { ProdChecklistFormComponent } from '../features/prod-visit/components/steps/prod-checklist/prod-checklist-form/prod-checklist-form.component';
import { ProdChecklistComponent } from '../features/prod-visit/components/steps/prod-checklist/prod-checklist.component';
import { ProdFinalWalkthroughFormComponent } from '../features/prod-visit/components/steps/prod-final-walkthrough/prod-final-walkthrough-form/prod-final-walkthrough-form.component';
import { ProdFinalWalkthroughComponent } from '../features/prod-visit/components/steps/prod-final-walkthrough/prod-final-walkthrough.component';
import { CustomerNotesComponent } from '../features/customer/components/customer-notes/customer-notes.component';
import { ProdVisitDetailsComponent } from '../features/prod-visit/components/steps/prod-visit-details/prod-visit-details.component';
import { ProdAdditionalWorkComponent } from '../features/prod-visit/components/steps/prod-additional-work/prod-additional-work.component';
import { DuplicateProductDialogComponent } from '../features/sales-visit/components/steps/proposal/duplicate-product-dialog/duplicate-product-dialog.component';
import { ProposalProductDialogComponent } from '../features/sales-visit/components/steps/proposal/proposal-product-dialog/proposal-product-dialog.component';
import { ProposalProductComponent } from '../features/sales-visit/components/steps/proposal/proposal-product/proposal-product.component';
import { ProposalTotalComponent } from '../features/sales-visit/components/steps/proposal/proposal-total/proposal-total.component';
import { ProposedProductComponent } from '../features/sales-visit/components/steps/proposal/proposed-product/proposed-product.component';
import { ServiceVisitComponent } from '../features/service-visit/components/service-visit/service-visit.component';
import { ServiceInvoicePdfComponent } from '../features/service-visit/components/service-invoice-pdf/service-invoice-pdf.component';
import { ServiceAdditionalWorkComponent } from '../features/service-visit/components/steps/service-additional-work/service-additional-work.component';
import { ServiceChecklistFormComponent } from '../features/service-visit/components/steps/service-checklist/service-checklist-form/service-checklist-form.component';
import { ServiceChecklistComponent } from '../features/service-visit/components/steps/service-checklist/service-checklist.component';
import { ServiceFinalWalkthroughFormComponent } from '../features/service-visit/components/steps/service-final-walkthrough/service-final-walkthrough-form/service-final-walkthrough-form.component';
import { ServiceFinalWalkthroughComponent } from '../features/service-visit/components/steps/service-final-walkthrough/service-final-walkthrough.component';
import { ServiceInitialWalkthroughFormComponent } from '../features/service-visit/components/steps/service-initial-walkthrough/service-initial-walkthrough-form/service-initial-walkthrough-form.component';
import { ServiceInitialWalkthroughComponent } from '../features/service-visit/components/steps/service-initial-walkthrough/service-initial-walkthrough.component';
import { ServiceReviewAndSignComponent } from '../features/service-visit/components/steps/service-review-and-sign/service-review-and-sign.component';
import { PaymentAndDepositComponent } from '../features/sales-visit/components/steps/review-and-sign/payment-and-deposit/payment-and-deposit.component';
import { JobStatusFormComponent } from '../features/sales-visit/components/steps/review-and-sign/job-status-form/job-status-form.component';
import { AddNoteComponent } from '../features/notes/add-note/add-note.component';
import { NotesListComponent } from '../features/notes/notes-list/notes-list.component';
import { SnackbarComponent } from '../features/snackbar/snackbar/snackbar.component';
import { ProdWrapUpComponent } from '../features/prod-visit/components/steps/prod-wrap-up/prod-wrap-up.component';
import { ServiceWrapUpComponent } from '../features/service-visit/components/steps/service-wrap-up/service-wrap-up.component';
import { SafePipe } from '../core/pipes/safe.pipe';
import { StatementEditDialogComponent } from '../features/sales-visit/components/statement-edit-dialog/statement-edit-dialog.component';
import { AddNoteDialogComponent } from '../features/notes/add-note-dialog/add-note-dialog.component';
import { MarkAsSoldDialogComponent } from '../features/sales-visit/components/mark-as-sold-dialog/mark-as-sold-dialog.component';
import { ProductSummaryComponent } from '../features/customer/components/product-summary/product-summary.component';
import { ChangeOrderDialogComponent } from '../features/customer/components/change-order-dialog/change-order-dialog.component';
import { ChangeOrderProductSummaryComponent } from '../features/customer/components/change-order-product-summary/change-order-product-summary.component';
import { UpsellProductSummaryComponent } from '../features/customer/components/upsell-product-summary/upsell-product-summary.component';
import { UpsellContractComponent } from '../features/upsell/components/upsell-contract/upsell-contract.component';
import { UpsellVisitComponent } from '../features/upsell/components/upsell-visit/upsell-visit.component';
import { ScheduleUpsellDialogComponent } from '../features/upsell/components/schedule-upsell-dialog/schedule-upsell-dialog.component';
import { CancelUpsellDialogComponent } from '../features/upsell/components/cancel-upsell-dialog/cancel-upsell-dialog.component';
import { PrivateNoteDialogComponent } from '../features/notes/private-note-dialog/private-note-dialog.component';
import { SalesSoldSheetComponent } from '../features/sales-visit/components/sales-sold-sheet/sales-sold-sheet.component';
import { SoldSheetDialogComponent } from '../features/customer/components/sold-sheet-dialog/sold-sheet-dialog.component';
import { NoBidDialogComponent } from '../features/sales-visit/components/no-bid-dialog/no-bid-dialog.component';
import { SalesVisitComponent } from '../features/sales-visit/components/sales-visit/sales-visit.component';
import { AttachmentsComponent } from '../features/sales-visit/components/steps/attachments/attachments.component';
import { ChecklistFormComponent } from '../features/sales-visit/components/steps/checklist/checklist-form/checklist-form.component';
import { ChecklistComponent } from '../features/sales-visit/components/steps/checklist/checklist.component';
import { ProposalDetailsComponent } from '../features/sales-visit/components/steps/details/proposal-details/proposal-details.component';
import { InitialWalkthroughFormComponent } from '../features/sales-visit/components/steps/initial-walkthrough/initial-walkthrough-form/initial-walkthrough-form.component';
import { InitialWalkthroughComponent } from '../features/sales-visit/components/steps/initial-walkthrough/initial-walkthrough.component';
import { PhotoComponent } from '../features/sales-visit/components/steps/photo/photo.component';
import { CustomDiscountModalComponent } from '../features/sales-visit/components/steps/proposal/proposal-total/components/custom-discount-modal/custom-discount-modal.component';
import { ProposalComponent } from '../features/sales-visit/components/steps/proposal/proposal.component';
import { StatementsDialogComponent } from '../features/sales-visit/components/steps/proposal/statements-dialog/statements-dialog.component';
import { ReviewAndSignComponent } from '../features/sales-visit/components/steps/review-and-sign/review-and-sign.component';
import { SketchComponent } from '../features/sales-visit/components/steps/sketch/sketch.component';
import { VideoComponent } from '../features/sales-visit/components/steps/video/video.component';
import { LeadInfoComponent } from '../features/customer/components/lead-info/lead-info.component';
import { DeleteAppointmentDialogComponent } from '../features/customer/components/delete-appointment-dialog/delete-appointment-dialog.component';
import { ChangeOrderContractComponent } from '../features/prod-visit/components/change-order-contract/change-order-contract.component';
import { ConfirmationDialogComponent } from '../features/shared/confirmation-dialog/confirmation-dialog.component';
import { ProdInvoicingTabComponent } from '../features/prod-visit/components/steps/prod-invoicing-tab/prod-invoicing-tab.component';
import { ProdInvoiceComponent } from '../features/prod-visit/components/steps/prod-invoice/prod-invoice.component';
import { ProdStatementComponent } from '../features/prod-visit/components/steps/prod-statement/prod-statement.component';
import { ProdStatementSelectComponent } from '../features/prod-visit/components/steps/prod-statement-select/prod-statement-select.component';
import { UpsellInvoiceComponent } from '../features/upsell/components/upsell-invoice/upsell-invoice.component';
import { InsideSalesComponent } from '../features/inside-sales/components/inside-sales/inside-sales.component';
import { SalesPresentationComponent } from '../features/sales-visit/components/sales-presentation/sales-presentation/sales-presentation.component';
import { AddFollowUpComponent } from '../features/customer/components/add-follow-up/add-follow-up.component';
import { FollowUpListComponent } from '../features/customer/components/follow-up-list/follow-up-list.component';
import { FollowUpTabComponent } from '../features/customer/components/follow-up-tab/follow-up-tab.component';
import { DispositionDialogComponent } from '../features/sales-visit/components/disposition-dialog/disposition-dialog.component';
import { DispoNeededDialogComponent } from '../features/dispositions/components/dispo-needed-dialog/dispo-needed-dialog.component';
import { AppointmentNeedingDispoComponent } from '../features/dispositions/components/appointment-needing-dispo/appointment-needing-dispo.component';
import { HotQuoteLimitDialogComponent } from '../features/dispositions/components/hot-quote-limit-dialog/hot-quote-limit-dialog.component';
import { HotQuoteInfoDialogComponent } from '../features/dispositions/components/hot-quote-info-dialog/hot-quote-info-dialog.component';
import { SentToInsideSalesListComponent } from '../features/inside-sales/components/sent-to-inside-sales-list/sent-to-inside-sales-list.component';
import { SoldNeedingSoldSheetDialogComponent } from '../features/dispositions/components/sold-needing-sold-sheet-dialog/sold-needing-sold-sheet-dialog.component';
import { UpsellDetailsComponent } from '../features/service-visit/components/steps/upsell-details/upsell-details.component';
import { DrawingComponent } from '../features/drawing/components/drawing/drawing.component';
import { CanvasComponent } from '../features/drawing/components/canvas/canvas.component';
import { DrawingControlsComponent } from '../features/drawing/components/drawing-controls/drawing-controls.component';
import { DrawingToolboxComponent } from '../features/drawing/components/drawing-toolbox/drawing-toolbox.component';
import { DrawingManagerComponent } from '../features/drawing/components/drawing-manager/drawing-manager.component';
import { DrawingInfoComponent } from '../features/drawing/components/drawing-info/drawing-info.component';
import { DrawingColorSelectorComponent } from '../features/drawing/components/drawing-color-selector/drawing-color-selector.component';
import { ViewDrawingDialogComponent } from '../features/drawing/components/view-drawing-dialog/view-drawing-dialog.component';
import { DrawingHelpScreenDialogComponent } from '../features/drawing/components/drawing-help-screen-dialog/drawing-help-screen-dialog.component';
import { NoteWrapperComponent } from '../features/notes/note-wrapper/note-wrapper.component';
import { SoldSheetConfirmationDialogComponent } from '../features/sales-visit/components/sold-sheet-confirmation-dialog/sold-sheet-confirmation-dialog.component';
import { ProdDailyComponent } from '../features/dailies/components/prod-daily/prod-daily.component';
import { ProdDailySelectComponent } from '../features/dailies/components/prod-daily-select/prod-daily-select.component';
import { ProdDailyMaterialsComponent } from '../features/dailies/components/prod-daily-materials/prod-daily-materials.component';
import { ProdDailyTimeComponent } from '../features/dailies/components/prod-daily-time/prod-daily-time.component';
import { ProdDailyBenchmarksComponent } from '../features/dailies/components/prod-daily-benchmarks/prod-daily-benchmarks.component';
import { ProdUpsellDetailsComponent } from '../features/dailies/components/prod-upsell-details/prod-upsell-details.component';
import { TimeConversionPipe } from '../core/pipes/time-conversion.pipe';
import { CrewClockComponent } from '../features/dailies/components/crew-clock/crew-clock.component';
import { ProdDailyInvoicingComponent } from '../features/dailies/components/prod-daily-invoicing/prod-daily-invoicing.component';
import { DailyPaymentInfoComponent } from '../features/dailies/components/daily-payment-info/daily-payment-info.component';
import { DailyIncompleteDialogComponent } from '../features/dailies/components/daily-incomplete-dialog/daily-incomplete-dialog.component';
import { IncompleteProjectDialogComponent } from '../features/dailies/components/incomplete-project-dialog/incomplete-project-dialog.component';
import { ProdDailyManagementComponent } from '../features/dailies/components/prod-daily-management/prod-daily-management.component';
import { DailyPromptDialogComponent } from '../features/dailies/components/daily-prompt-dialog/daily-prompt-dialog.component';
import { DailyPromptResponseComponent } from '../features/dailies/components/daily-prompt-response/daily-prompt-response.component';
import { AppointmentsNeedingDailyDialogComponent } from '../features/dailies/components/appointments-needing-daily-dialog/appointments-needing-daily-dialog.component';
import { IncompleteProjectFormComponent } from '../features/dailies/components/incomplete-project-form/incomplete-project-form.component';
import { TimeExtensionDialogComponent } from '../features/dailies/components/time-extension-dialog/time-extension-dialog.component';
import { FinalWrapUpDialogComponent } from '../features/dailies/components/final-wrap-up-dialog/final-wrap-up-dialog.component';
import { AssuranceInvoiceComponent } from '../features/shared/assurance-invoice/assurance-invoice.component';
import { ProjectInfoComponent } from '../features/customer/components/project-info/project-info.component';
import { PermitFormComponent } from '../features/permits/components/permit-form/permit-form.component';
import { PermitTableComponent } from '../features/permits/components/permit-table/permit-table.component';
import { UtilitiesFormComponent } from '../features/utilities/components/utilities-form/utilities-form.component';
import { UtilitiesTableComponent } from '../features/utilities/components/utilities-table/utilities-table.component';
import { CustomerDrawingsComponent } from '../features/customer/components/customer-drawings/customer-drawings.component';
import { SyncDialogComponent } from '../features/sync/components/sync-dialog/sync-dialog.component';
import { TimeZoneDatePipe } from '../core/pipes/time-zone.pipe';
import { AppointmentTimePipe } from '../core/pipes/appointment-time.pipe';
import { DrawingAttachmentInfoComponent } from '../features/drawing/components/drawing-attachment-info/drawing-attachment-info.component';
import { ViewDrawingAttachmentDialogComponent } from '../features/drawing/components/view-drawing-attachment-dialog/view-drawing-attachment-dialog.component';

@NgModule({
  declarations: [
    // Prod Visit Module
    ProdInitialWalkthroughComponent,
    ProdInitialWalkthroughFormComponent,
    ProdChecklistComponent,
    ProdChecklistFormComponent,
    ProdFinalWalkthroughComponent,
    ProdFinalWalkthroughFormComponent,
    ProdVisitDetailsComponent,
    ProdAdditionalWorkComponent,
    ProdWrapUpComponent,
    ChangeOrderContractComponent,
    ProdInvoicingTabComponent,
    ProdInvoiceComponent,
    ProdStatementComponent,
    ProdStatementSelectComponent,
    // Customer Module
    CustomerDetailsFormComponent,
    JobAddressFormComponent,
    CustomerAttachmentsComponent,
    CustomerNotesComponent,
    ProductSummaryComponent,
    ChangeOrderDialogComponent,
    ChangeOrderProductSummaryComponent,
    UpsellProductSummaryComponent,
    LeadInfoComponent,
    DeleteAppointmentDialogComponent,
    FollowUpTabComponent,
    FollowUpListComponent,
    AddFollowUpComponent,
    ProjectInfoComponent,
    CustomerDrawingsComponent,
    // Permit
    PermitFormComponent,
    PermitTableComponent,
    // Utilities
    UtilitiesFormComponent,
    UtilitiesTableComponent,
    // Sales Visit Module
    ContractPdfComponent,
    ProposalTotalComponent,
    ProposalProductComponent,
    ProposalProductDialogComponent,
    ProposedProductComponent,
    DuplicateProductDialogComponent,
    PaymentAndDepositComponent,
    JobStatusFormComponent,
    StatementEditDialogComponent,
    MarkAsSoldDialogComponent,
    SalesSoldSheetComponent,
    SoldSheetConfirmationDialogComponent,
    SoldSheetDialogComponent,
    SalesVisitComponent,
    NoBidDialogComponent,
    PhotoComponent,
    VideoComponent,
    InitialWalkthroughComponent,
    ChecklistComponent,
    ProposalComponent,
    AttachmentsComponent,
    SketchComponent,
    ReviewAndSignComponent,
    ChecklistFormComponent,
    InitialWalkthroughFormComponent,
    CustomDiscountModalComponent,
    ProposalDetailsComponent,
    StatementsDialogComponent,
    DetailsComponent,
    SalesPresentationComponent,
    DispositionDialogComponent,
    // Service Visit Module
    ServiceVisitComponent,
    ServiceAdditionalWorkComponent,
    ServiceInitialWalkthroughComponent,
    ServiceInitialWalkthroughFormComponent,
    ServiceChecklistComponent,
    ServiceChecklistFormComponent,
    ServiceFinalWalkthroughComponent,
    ServiceFinalWalkthroughFormComponent,
    ServiceReviewAndSignComponent,
    ServiceInvoicePdfComponent,
    ServiceWrapUpComponent,
    UpsellDetailsComponent,
    // Notes
    AddNoteComponent,
    NotesListComponent,
    AddNoteDialogComponent,
    PrivateNoteDialogComponent,
    NoteWrapperComponent,
    // Snackbar
    SnackbarComponent,
    // Pipes
    SafePipe,
    TimeConversionPipe,
    TimeZoneDatePipe,
    AppointmentTimePipe,
    // Upsell
    UpsellContractComponent,
    UpsellVisitComponent,
    ScheduleUpsellDialogComponent,
    CancelUpsellDialogComponent,
    UpsellInvoiceComponent,
    // Sync
    SyncDialogComponent,
    // Shared
    ConfirmationDialogComponent,
    AssuranceInvoiceComponent,
    // Inside Sales
    InsideSalesComponent,
    SentToInsideSalesListComponent,
    // Dispositions
    DispoNeededDialogComponent,
    AppointmentNeedingDispoComponent,
    HotQuoteLimitDialogComponent,
    HotQuoteInfoDialogComponent,
    SoldNeedingSoldSheetDialogComponent,
    // Drawing
    DrawingComponent,
    CanvasComponent,
    DrawingControlsComponent,
    DrawingToolboxComponent,
    DrawingManagerComponent,
    DrawingInfoComponent,
    DrawingColorSelectorComponent,
    ViewDrawingDialogComponent,
    DrawingHelpScreenDialogComponent,
    DrawingAttachmentInfoComponent,
    ViewDrawingAttachmentDialogComponent,
    // Dailies
    ProdDailyComponent,
    ProdDailySelectComponent,
    ProdDailyMaterialsComponent,
    ProdDailyTimeComponent,
    ProdDailyBenchmarksComponent,
    ProdUpsellDetailsComponent,
    CrewClockComponent,
    ProdDailyInvoicingComponent,
    DailyPaymentInfoComponent,
    DailyIncompleteDialogComponent,
    IncompleteProjectDialogComponent,
    ProdDailyManagementComponent,
    DailyPromptDialogComponent,
    DailyPromptResponseComponent,
    AppointmentsNeedingDailyDialogComponent,
    IncompleteProjectFormComponent,
    TimeExtensionDialogComponent,
    FinalWrapUpDialogComponent,
  ],
  imports: [CommonModule, SharedModule],
  exports: [
    // Prod Visit Module
    ProdInitialWalkthroughComponent,
    ProdInitialWalkthroughFormComponent,
    ProdChecklistComponent,
    ProdChecklistFormComponent,
    ProdFinalWalkthroughComponent,
    ProdFinalWalkthroughFormComponent,
    ProdVisitDetailsComponent,
    ProdAdditionalWorkComponent,
    ProdWrapUpComponent,
    ChangeOrderContractComponent,
    ProdInvoicingTabComponent,
    ProdInvoiceComponent,
    ProdStatementComponent,
    ProdStatementSelectComponent,
    // Customer Module
    CustomerDetailsFormComponent,
    JobAddressFormComponent,
    CustomerAttachmentsComponent,
    CustomerNotesComponent,
    ProductSummaryComponent,
    ChangeOrderDialogComponent,
    ChangeOrderProductSummaryComponent,
    UpsellProductSummaryComponent,
    LeadInfoComponent,
    DeleteAppointmentDialogComponent,
    FollowUpTabComponent,
    FollowUpListComponent,
    AddFollowUpComponent,
    ProjectInfoComponent,
    CustomerDrawingsComponent,
    // Permit
    PermitFormComponent,
    PermitTableComponent,
    // Utilities
    UtilitiesFormComponent,
    UtilitiesTableComponent,
    // Sales Visit Module
    ContractPdfComponent,
    ProposalTotalComponent,
    ProposalProductComponent,
    ProposalProductDialogComponent,
    ProposedProductComponent,
    DuplicateProductDialogComponent,
    PaymentAndDepositComponent,
    JobStatusFormComponent,
    StatementEditDialogComponent,
    MarkAsSoldDialogComponent,
    SalesSoldSheetComponent,
    SoldSheetConfirmationDialogComponent,
    SoldSheetDialogComponent,
    SalesVisitComponent,
    NoBidDialogComponent,
    PhotoComponent,
    VideoComponent,
    InitialWalkthroughComponent,
    ChecklistComponent,
    ProposalComponent,
    AttachmentsComponent,
    SketchComponent,
    ReviewAndSignComponent,
    ChecklistFormComponent,
    InitialWalkthroughFormComponent,
    CustomDiscountModalComponent,
    ProposalDetailsComponent,
    StatementsDialogComponent,
    DetailsComponent,
    SalesPresentationComponent,
    DispositionDialogComponent,
    // Service Visit Module
    ServiceVisitComponent,
    ServiceAdditionalWorkComponent,
    ServiceInitialWalkthroughComponent,
    ServiceInitialWalkthroughFormComponent,
    ServiceChecklistComponent,
    ServiceChecklistFormComponent,
    ServiceFinalWalkthroughComponent,
    ServiceFinalWalkthroughFormComponent,
    ServiceReviewAndSignComponent,
    ServiceInvoicePdfComponent,
    ServiceWrapUpComponent,
    UpsellDetailsComponent,
    // Notes
    AddNoteComponent,
    NotesListComponent,
    AddNoteDialogComponent,
    PrivateNoteDialogComponent,
    NoteWrapperComponent,
    // Snackbar
    SnackbarComponent,
    // Pipes
    SafePipe,
    TimeConversionPipe,
    TimeZoneDatePipe,
    AppointmentTimePipe,
    // Upsell
    UpsellContractComponent,
    UpsellVisitComponent,
    ScheduleUpsellDialogComponent,
    CancelUpsellDialogComponent,
    UpsellInvoiceComponent,
    // Sync
    SyncDialogComponent,
    // Shared
    ConfirmationDialogComponent,
    AssuranceInvoiceComponent,
    // Inside Sales
    InsideSalesComponent,
    SentToInsideSalesListComponent,
    // Dispositions
    DispoNeededDialogComponent,
    AppointmentNeedingDispoComponent,
    HotQuoteLimitDialogComponent,
    HotQuoteInfoDialogComponent,
    SoldNeedingSoldSheetDialogComponent,
    // Drawing
    DrawingComponent,
    CanvasComponent,
    DrawingControlsComponent,
    DrawingToolboxComponent,
    DrawingManagerComponent,
    DrawingInfoComponent,
    DrawingColorSelectorComponent,
    ViewDrawingDialogComponent,
    DrawingHelpScreenDialogComponent,
    DrawingAttachmentInfoComponent,
    ViewDrawingAttachmentDialogComponent,
    // Dailies
    ProdDailyComponent,
    ProdDailySelectComponent,
    ProdDailyMaterialsComponent,
    ProdDailyTimeComponent,
    ProdDailyBenchmarksComponent,
    ProdUpsellDetailsComponent,
    CrewClockComponent,
    ProdDailyInvoicingComponent,
    DailyPaymentInfoComponent,
    DailyIncompleteDialogComponent,
    IncompleteProjectDialogComponent,
    ProdDailyManagementComponent,
    DailyPromptDialogComponent,
    DailyPromptResponseComponent,
    AppointmentsNeedingDailyDialogComponent,
    IncompleteProjectFormComponent,
    TimeExtensionDialogComponent,
    FinalWrapUpDialogComponent,
  ],
})
export class SharedComponentModule {}
